export default function PHP_array_splice() {
  return (
    <div>
      <h1>PHP_array_splice</h1>
    </div>
  );
}
